import { OrgRole, ProjectRole } from '@app-types/access';
import { IUser } from '@store/slices/auth/authSlice';

export const getOrgRoleForOrg = (user: IUser | null, orgId?: string): OrgRole | undefined => {
  if (!user || !orgId) {
    return undefined;
  }
  return user.memberships?.find(membership => membership.orgId === orgId)?.role;
};

export const isOrgAdmin = (user: IUser | null, orgId?: string): boolean =>
  getOrgRoleForOrg(user, orgId) === 'admin';

export const getProjectRoleForProject = (
  user: IUser | null,
  projectId?: string,
  orgId?: string
): ProjectRole | undefined => {
  if (!user || !projectId) {
    return undefined;
  }
  if (orgId && isOrgAdmin(user, orgId)) {
    return 'admin';
  }
  return user.projects?.find(
    project => project.projectId === projectId || project._id === projectId
  )?.role;
};

export const canManageProjectMembers = (role?: ProjectRole): boolean =>
  role === 'admin' || role === 'deployer';

export const canManageChannels = (role?: ProjectRole): boolean =>
  role === 'admin' || role === 'deployer';
